import { useAsync, } from 'react-use';
import { isEmpty, } from 'lodash';
import { format as formatDate, addMonths, } from 'date-fns';

import { getCollectionData, getDocumentData, } from '../../shared/firebase';
import { computeSegmentsAmounts, computeCompaniesAmounts, } from '../../shared/models/consolidationAccountItem';

export default function useMonthlySegmentsAmounts (company, relatedCompanies, allConsolidationJournalTypes, allConsolidationAccountItems, accountItems, sections, allConsolidationSegments, yearMonthDates) {
  const computeMonthItems = async () => {
    if(isEmpty(yearMonthDates) || !relatedCompanies || !allConsolidationJournalTypes || !allConsolidationAccountItems || isEmpty(accountItems) || !sections || !allConsolidationSegments) return;

    const getData = async (yearMonthDate) => {
      const yearMonth = formatDate(yearMonthDate, 'yyyyMM');
      const [trials, sectionTrials, individualAdjustmentJournals, consolidationJournals, exchangedItems, exchangeRate] = await Promise.all([
        getCollectionData(company.ref.collection('trials').where('yearMonth', '==', yearMonth)),
        getCollectionData(company.ref.collection('sectionTrials').where('yearMonth', '==', yearMonth)),
        getCollectionData(company.ref.collection('individualAdjustmentJournals').where('yearMonth', '==', yearMonth)),
        getCollectionData(company.ref.collection('consolidationJournals').where('yearMonth', '==', yearMonth)),
        getCollectionData(company.ref.collection('exchangedItems').where('yearMonth', '==', yearMonth)),
        getDocumentData(company.ref.collection('exchangeRates').doc(yearMonth)),
      ]);
      return { yearMonth, trials, sectionTrials, individualAdjustmentJournals, consolidationJournals, exchangedItems, exchangeRate };
    };
    const allMonthGroups = await Promise.all(yearMonthDates.map(getData));
    const prevMonthGroup = company.usesMonthlyAr ? await getData(addMonths(yearMonthDates[0], -1)) : null;
    return yearMonthDates.map((yearMonthDate, i) => {
      const monthGroups = company.usesMonthlyAr ? allMonthGroups.slice(0, i + 1) : [allMonthGroups[i]];
      return {
        yearMonth: formatDate(yearMonthDate, 'yyyyMM'),
        items: computeSegmentsAmounts(company, relatedCompanies, allConsolidationAccountItems, accountItems, sections, allConsolidationSegments, monthGroups, prevMonthGroup),
        consolidationCalculationItems: computeCompaniesAmounts(company, relatedCompanies, allConsolidationJournalTypes, allConsolidationAccountItems, accountItems, monthGroups, prevMonthGroup, undefined, false, true),
      };
    });
  };
  const { value: monthItems, loading: isLoading, error, } = useAsync(computeMonthItems, [company, relatedCompanies, allConsolidationJournalTypes, allConsolidationAccountItems, accountItems, sections, allConsolidationSegments, yearMonthDates]);
  if(error) throw error;

  return { monthItems, isLoading, };
};
